import { Role, User } from 'types';
import { RoleTranslationsMap } from 'utils/role';

export const getUserFullName = (
  user: User | Pick<User, 'name'>,
): string => {
  if (user.name === null) {
    user.name = '';
  }

  return `${user.name}`;
};

export const getUserRole = (role: Role): string => RoleTranslationsMap[role];
